import { useTranslation } from 'react-i18next';

export default function ContactSection() {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-24 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 text-gray-900">
          {t('contact_title')}
        </h2>
        <p className="text-center text-gray-600 mb-16 text-lg">
          {t('contact_subtitle')}
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-bold mb-6 text-gray-900">{t('footer_contact_info')}</h3>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full flex-shrink-0">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">{t('footer_email')}</h4>
                  <a href="mailto:guidali.enrico@gmail.com" className="text-gray-600 hover:text-gray-900 transition-colors">
                    guidali.enrico@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">{t('footer_address')}</h4>
                  <p className="text-gray-600">
                    Via Binaghetto 3<br />
                    21051 Arcisate (VA)<br />
                    Italy
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full flex-shrink-0">
                  <i className="ri-time-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">{t('footer_viewing_hours')}</h4>
                  <p className="text-gray-600">
                    {t('footer_viewing_hours_text')}<br />
                    {t('footer_viewing_days')}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full flex-shrink-0">
                  <i className="ri-price-tag-3-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">{t('footer_price')}</h4>
                  <p className="text-gray-600 text-2xl font-bold text-gray-900">
                    {t('footer_price_value')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="text-center mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-gray-900 rounded-full mx-auto mb-4">
                  <i className="ri-calendar-check-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{t('viewing_title')}</h3>
              </div>
              
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p className="text-base">
                  {t('viewing_intro')}
                </p>
                
                <p className="text-base">
                  {t('viewing_translator')}
                </p>
                
                <p className="text-base">
                  {t('viewing_flexible')}
                </p>
                
                <p className="text-base">
                  {t('viewing_contact')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
